"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useStyles = exports.default = void 0;
var _react = require("react");
var _css = require("@emotion/css");
var _hooks = require("../../../../../hooks");
const useStyles = props => {
  const {
    scrollProps,
    pxToRem
  } = (0, _hooks.useStylesUtils)();
  const {
    isMobileView
  } = (0, _hooks.useDeviceData)();
  const ccAudiencePickerAudienceSelectListStyle = (0, _react.useMemo)(() => {
    const deviceProps = () => {
      if (!isMobileView) {
        return {
          paddingInlineEnd: pxToRem(5),
          marginInlineEnd: pxToRem(-5)
        };
      }
      return {};
    };
    const ccAudiencePickerAudienceSelectList = (0, _css.css)({
      flex: 'auto',
      overflowY: 'auto',
      overflowX: 'hidden',
      marginBlockEnd: '1.2rem',
      ...deviceProps(),
      ...scrollProps()
    });
    return {
      ccAudiencePickerAudienceSelectList
    };
  }, [isMobileView, pxToRem, scrollProps]);
  return {
    'cc-AudiencePicker__audience-select-list': ccAudiencePickerAudienceSelectListStyle.ccAudiencePickerAudienceSelectList
  };
};
exports.useStyles = useStyles;
var _default = exports.default = useStyles;